module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_15_4.734efa84.jpeg";